// extracted by mini-css-extract-plugin
export var root = "J_wq";
export var wrapper = "J_pD";
export var image = "J_wr d_w d_y d_W";
export var imageWithHeight = "J_ws";
export var crop = "J_wt";
export var round = "J_wv";
export var fixedHeight = "J_ww";